import { createSlice } from "@reduxjs/toolkit";

export const skuSectionSlice = createSlice({
  name: "skuSection",
  initialState: {
    visible: true,
  },
  reducers: () => ({
    toggleSkuSections(state) {
      state.visible = !state.visible;
    },
  }),
});

export const { toggleSkuSections } = skuSectionSlice.actions;
